import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import { times } from 'lodash-es';

import AppIcon from '../../../../components/AppIcon';
import Skeleton from '../../../../components/Skeleton';
import { aiDashboardAppsSelector } from '../selectors';
import { SECTIONS_IDS } from '../configs/sections';

const StickyAppsLine = ({ active }) => {
  const apps = useSelector(aiDashboardAppsSelector);

  const showTopApps = active.id !== SECTIONS_IDS.marketOverview;
  const visibleApps = (showTopApps ? apps.data?.top_apps : apps.data?.apps) || [];

  if (apps.settings.error || (!apps.settings.pending && !visibleApps.length)) return null;

  return (
    <div key={showTopApps ? 'top' : 'all'} className="dashboard-sticky-header__apps">
      {apps.settings.pending
        ? times(5).map((i) => <Skeleton key={i} height={32} width={32} />)
        : visibleApps.map((app) => (
            <AppIcon
              key={app.ref_no}
              url={app.icon_url}
              store={app.store}
              size={32}
              alt={app.nickname}
              withBorder
            />
          ))}
    </div>
  );
};

StickyAppsLine.propTypes = {
  active: T.shape({ id: T.string.isRequired }).isRequired,
};

export default StickyAppsLine;
